export function serializeForm (form) {
    const retrieved = {}
    if (form) {
        const data = new FormData(form)
        for (const field of data.entries()) {
            retrieved[field[0]] = field[1]
        }
    }

    return retrieved
}